import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { LoadingOverlay, EventList, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";

class ApiKeyAudit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectRecordDetail: null
        }
    }

    componentWillMount() {
        this.props.getApiKeyEvents(this.props.apiKey.apiKeyId);
        this.setState({
            fetchingEvents: true
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetApiKeyEventsResultUpdate(prevProps);
    }

    onGetApiKeyEventsResultUpdate = (prevProps) => {
        if (this.props.getApiKeyEventsResult && this.props.getApiKeyEventsResult !== prevProps.getApiKeyEventsResult) {
            if (!this.props.getApiKeyEventsResult.success) {
                if (this.props.getApiKeyEventsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get API key events.");
                }
            }
            this.setState({
                fetchingEvents: false
            });
        }
    }

    render() {
        return (
            <FullHeightContainerLayout
                showHeader={false}
                showFooter={false}
                content={
                    this.state.fetchingEvents
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message="Getting API key events...">
                        </LoadingOverlay>
                        :
                        <EventList eventList={this.props.apiKeyEventsResult.Items}></EventList>
                }>
            </FullHeightContainerLayout>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getApiKeyEventsResult: state.apiKeyAudit.getApiKeyEventsResult,
        apiKeyEventsResult: state.apiKeyAudit.apiKeyEventsResult
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getApiKeyEvents: (apiKeyId) => dispatch(actions.getApiKeyEventsRequest(apiKeyId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ApiKeyAudit));
